import {EFormStep} from './definitions';

export default {
  signInButton: 'Log in',
  signInHint: 'Already have an account?',
  formStepsInfo: {
    [EFormStep.COUNTRY]: {
      title: 'Where is your company registered?',
      hint: 'Select the country where your legal entity is registered',
    },
    [EFormStep.NAME]: {
      title: 'What is your name?',
      hint: 'Full name',
    },
    [EFormStep.PHONE]: {
      title: 'Phone number',
      hint: 'Contact and verification number',
    },
    [EFormStep.EMAIL]: {
      title: 'Email',
      hint: 'We will send a confirmation link to this email',
    },
  },
  formStepsTitle: {
    [EFormStep.COUNTRY]: 'Country',
    [EFormStep.NAME]: 'Company owner',
    [EFormStep.PHONE]: 'Phone number',
    [EFormStep.EMAIL]: 'Email',
  },
  form: {
    countryLabel: 'Select a country',
    countryHint:
      'If your country is not on the list, please follow this link to register: <0>{{link}}</0>',
    nameLabel: 'Full name',
    emailLabel: 'Your email',
    captchaLabel: 'Enter the characters shown in the image',
    agreementCondition: 'I <0>agree</0> to <1>the personal data processing policy</1>',
    advertisementCondition:
      'I agree to receive advertising messages from edna, company news, interesting case studies, and market trends',
    termsAndConditions:
      '<0>By clicking the button, you accept</0><br/>' + '<1>the Terms of Use</1>',
    emailExistError:
      'A user with this email already exists. Change your email or log in to your existing account',
  },
  success: {
    title: 'Check your e-mail',
    hint:
      'Follow the link in the email we sent you, and you’re all set!\n' +
      '<0>The link is valid for 24 hours</0>',
    managerSupport: 'Our manager will contact you',
  },
  error: {
    title: 'Something went wrong',
    hint: 'An unexpected error occurred during registration.\n\n' + 'Please try again later',
  },
  mobile: {
    formStepsInfo: {
      [EFormStep.PHONE]: {title: 'Contact and verification number'},
      [EFormStep.EMAIL]: {title: 'E-mail'},
    },
    form: {
      captchaLabel: 'Enter the digits from the image',
      advertisementCondition: 'I agree to receive advertising messages from edna',
      emailExistError: 'A user with this email already exists. Change your email or log in',
    },
    error: {
      hint:
        'We are sorry, an unexpected error occurred during registration\n\n' +
        'Please try again later',
    },
  },
};
